// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.memberViewInfoTabTwo {
  margin-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
}
.memberViewInfoTabTwo .heading {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-top: 32px;
  color: #333333;
  position: relative;
}
.memberViewInfoTabTwo .headingWithSettings {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  position: relative;
  display: flex;
  align-content: space-between;
}
.memberViewInfoTabTwo .headingDark-type2 {
  width: 132px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  position: relative;
}
.memberViewInfoTabTwo .settingsWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
}
.memberViewInfoTabTwo .settingsWrapper .pencilImage, .memberViewInfoTabTwo .settingsWrapper .trashIcon, .memberViewInfoTabTwo .settingsWrapper .add_circle {
  height: 18px;
  width: 18px;
  margin-right: 2px;
}
.memberViewInfoTabTwo .settingsWrapper + .settingsWrapper {
  margin-left: 10px;
}
.memberViewInfoTabTwo .section {
  display: flex;
  margin-top: 20px;
}
.memberViewInfoTabTwo .section .content {
  display: flex;
}
.memberViewInfoTabTwo .label {
  text-align: left !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  position: relative;
  width: 132px;
}
.memberViewInfoTabTwo .value {
  flex: 1 1;
  display: flex;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}
.memberViewInfoTabTwo .value .menuBtn {
  display: flex;
}
.memberViewInfoTabTwo .grayValue {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #C1C1C1;
  display: inline-block;
}
.memberViewInfoTabTwo .redType {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #874a3d;
  padding: 2px 6px;
  display: inline-block;
  background-color: #f9e0da;
  border-radius: 4px;
}
.memberViewInfoTabTwo .blueType {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #385b7d;
  padding: 2px 6px;
  display: inline-block;
  background-color: #d5e5f3;
  border-radius: 4px;
}
.memberViewInfoTabTwo .accountInfo {
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/screens/viewInformation/tabTwoView/tabTwoView.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;AACJ;AAGI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AADR;AAGI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,4BAAA;AADR;AAII;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAFR;AAII;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAIQ;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AAFZ;AAKI;EACI,iBAAA;AAHR;AAKI;EACI,aAAA;EACA,gBAAA;AAHR;AAKQ;EACI,aAAA;AAHZ;AAOI;EACI,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AALR;AAQI;EACI,SAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AANR;AAQQ;EACI,aAAA;AANZ;AASI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAPR;AAUI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AARR;AAWI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AATR;AAYI;EACI,gBAAA;AAVR","sourcesContent":[".memberViewInfoTabTwo {\n    margin-top: 30px;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    .heading {\n        \n    }\n    .heading {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        margin-top: 32px;\n        color: #333333;\n        position: relative;\n    }\n    .headingWithSettings {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #333333;\n        position: relative;\n        display: flex;\n        align-content: space-between;\n\n    }\n    .headingDark-type2 {\n        width: 132px;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #333333;\n        position: relative;\n    }\n    .settingsWrapper {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #505054;\n\n        .pencilImage, .trashIcon, .add_circle {\n            height: 18px;\n            width: 18px;\n            margin-right: 2px;\n        }\n    }\n    .settingsWrapper+.settingsWrapper {\n        margin-left: 10px;\n    }\n    .section {\n        display: flex;\n        margin-top: 20px;\n\n        .content {\n            display: flex;\n        }\n    }\n\n    .label {\n        text-align: left!important;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #868686;\n        position: relative;\n        width: 132px;\n    }\n\n    .value {\n        flex: 1;\n        display: flex;\n        justify-content: space-between;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #333333;\n\n        .menuBtn {\n            display: flex;\n        }\n    }\n    .grayValue {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #C1C1C1;\n        display: inline-block;\n    }\n\n    .redType {\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #874a3d;\n        padding: 2px 6px;\n        display: inline-block;\n        background-color: #f9e0da;\n        border-radius: 4px;\n    }\n\n    .blueType {\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #385b7d;\n        padding: 2px 6px;\n        display: inline-block;\n        background-color: #d5e5f3;\n        border-radius: 4px;\n    }\n\n    .accountInfo {\n        margin-top: 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
